import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MailStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M21.25 6C21.25 5.30964 20.6904 4.75 20 4.75H4C3.30964 4.75 2.75 5.30964 2.75 6V18C2.75 18.6904 3.30964 19.25 4 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V6ZM22.75 18C22.75 19.5188 21.5188 20.75 20 20.75H4C2.48122 20.75 1.25 19.5188 1.25 18V6C1.25 4.48122 2.48122 3.25 4 3.25H20C21.5188 3.25 22.75 4.48122 22.75 6V18Z"
				fill="currentColor"
			/>
			<path
				d="M22.335 7.6709L13.2295 12.2236C12.4555 12.6105 11.5445 12.6105 10.7705 12.2236L1.66504 7.6709L2.33496 6.3291L11.4414 10.8818C11.7931 11.0576 12.2069 11.0576 12.5586 10.8818L21.665 6.3291L22.335 7.6709Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MailStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MailStrokeIcon;
